import { render, staticRenderFns } from "./ColumnsSaveDialog.vue?vue&type=template&id=1c0209a6"
import script from "./ColumnsSaveDialog.vue?vue&type=script&lang=js"
export * from "./ColumnsSaveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports